import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TableList } from '../db-template.model';
import { MainStore } from 'src/app/common/main.store';
import { Router } from '@angular/router';
import { DbTemplateService } from '../db-template.service';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { FormsModule } from '@angular/forms';
import { ErrorService } from '../../../../common/errors/error.service';

@Component({
    selector: 'app-db-template-copy',
    templateUrl: './db-template-copy.component.html',
    styleUrl: './db-template-copy.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class DbTemplateCopyComponent {

  isAdminUser: boolean = false;
  isLoading: boolean = true;
  dbTables: TableList[] = [];
 
  selectedGuid: string = '';
  isCopyingTemplate: boolean = false;

  constructor(
      public activeModal: NgbActiveModal,
      private store: MainStore,
      private router: Router,
      private templateService: DbTemplateService,
      private toastrService: ToastrService,
      private ngmService: NgbModal,
      private commonService: CommonService,
      private errorService: ErrorService
  ) {
    this.isAdminUser = this.store.currentUser.get().isAdmin && this.store.currentUser.get().departmentCode == '200'    
  }
      
  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    if (this.isAdminUser) {
        this.dbTables = await this.templateService.getDbTables();
        this.selectedGuid = this.dbTables[0].id;
        this.isLoading = false;
     }
     else {
        this.errorService.notify("Du har ikke adgang til denne funktion!", { tier: 'modal' });
        this.ngmService.dismissAll();
    }
  }

  copyDbTable(): void {
    this.isCopyingTemplate = true;
    this.templateService.copyDbTemplate(this.selectedGuid).then((newid: string) => {
      this.toastrService.success("skabelon kopieret");
      this.router.navigate(['/db-template/'+ newid]);      
      this.activeModal.close("close click");
    }).catch(() => {
      // HTTP-fejl vises globalt af GlobalErrorInterceptor/ErrorService
    }).finally(() => {
      this.isCopyingTemplate = false;
    });
  }

  disabled(): boolean {
    if (! this.isCopyingTemplate && this.selectedGuid.length > 0)
    {
      return false;
    }
    return true;
  }
}
